<div class="container vsp-container">
    <app-header *ngIf="!isSummaryPage"></app-header>
    <app-alert [sticky]="true" *ngIf="!isSummaryPage"></app-alert>
    <router-outlet></router-outlet>
    <app-footer *ngIf="!isSummaryPage"></app-footer>
</div>
